import { __assign, __awaiter, __generator } from "tslib";
import { app as api } from '@ekuaibao/whispered';
import { addNcpcCode } from '@ekuaibao/lib/lib/addNcpcCode';
import { app, callback, preloadMfePlugin, startFmpPrefetch, startMfeLoad } from '../index.v0';
import FSOpenSDK from '@ekuaibao/sdk-bridge/sdk/fsopen';
import registerAPI from '../registerAPI';
import { initializeTitle } from '../initializeTitle';
import initPlatformInfo from '../initPlatformInfo';
import qs from 'qs';
import { newHomeConfig } from '../newHomeConfig';
import registerHandler from '../registerHandler';
import { initRoute, setFirstScreenRoute } from '../initRoute';
import { initColors } from '../initColors';
import { Fetch } from '@ekuaibao/fetch';
import setNetworkAdapter from '../setNetworkAdapter';
import { session } from '@ekuaibao/session-info';
require('../../styles/app.less');
import initLogger from '../../logger/initLogger';
import { initDatafluxRum } from '../dataflux-rum';
import { trackFMP } from '../../lib/utils';
import { initFeatBit, anonymousUser, switchFeatBitUser } from '../../lib/featbit';
import { initializeI18n, setStaffDefaultLanguage } from '../i18n-initialize';
import * as SW from '../../lib/swEntrance';
initDatafluxRum();
initLogger();
window.__PLANTFORM__ = 'THIRDPARTY';
var params = qs.parse(location.search.slice(1), { decoder: function (str) { return decodeURIComponent(str); } });
function redirect() {
    switch (params['pageType']) {
        case 'payment':
            return '/audit/payment';
        case 'home':
            return '/bills';
        case 'frontPage':
            return '/new-homepage';
        case 'approve':
            return '/audit/approve';
        case 'receiveExpress':
            return '/audit/receiveExpress';
        case 'invoiceReview':
            return '/invoice-review';
        case 'form':
            var backlogId = params.backlogId, flowId = params.flowId;
            return "/backlogDetail/" + !!backlogId + "/" + (backlogId || flowId);
        case 'customPathname':
            return params['customPathname'];
        case 'backlogDetail':
            return '/billEntryDetail';
        case 'edit':
            return '/billEntryDetail';
        case 'expenseTracker':
            return '/record-expends';
    }
    return void 0;
}
function startup() {
    var params = qs.parse(location.search.slice(1));
    if (params === null || params === void 0 ? void 0 : params.billentry) {
        window.__SUB_PLANNTFORM__ = 'BILLENTRY';
    }
    app.use({
        id: '@thirdparty',
        onready: function () {
            addNcpcCode();
        }
    });
    callback();
}
var init = function () { return __awaiter(void 0, void 0, void 0, function () {
    var user, user_1, href, flag, user_2, page, e_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                preloadMfePlugin();
                initColors();
                app.container.set('IDeviceType', 'DESKTOP');
                app.container.set('ISMessageEntry', false);
                app.sdk = app.container.get(FSOpenSDK);
                if (params['accessToken']) {
                    Fetch.accessToken = params['accessToken'];
                }
                registerHandler();
                user = session.get('user') || {};
                if (params['ekbCorpId'] && (user === null || user === void 0 ? void 0 : user.corpId) !== params['ekbCorpId']) {
                    session.set('user', __assign(__assign({}, user), { corpId: params['ekbCorpId'] }));
                }
                if (window.IS_SMG) {
                    user_1 = session.get('user');
                    href = window.location.href || '';
                    flag = href.indexOf('flowId=') === -1;
                    if (flag && user_1 && user_1.corpId && user_1.corpId !== Fetch.ekbCorpId) {
                        Fetch.ekbCorpId = user_1.corpId;
                    }
                }
                if ((params['urlCorpId'] || params['ekbCorpId'] || params['corpId']) && window.__PLANTFORM__ === 'THIRDPARTY') {
                    user_2 = session.get('user');
                    if (!(user_2 === null || user_2 === void 0 ? void 0 : user_2.isChangeCorp)) {
                        session.set('user', {
                            corpId: params['urlCorpId'] || params['ekbCorpId'] || params['corpId'],
                            accessToken: params['accessToken']
                        });
                    }
                }
                page = redirect();
                _a.label = 1;
            case 1:
                _a.trys.push([1, 5, , 6]);
                return [4, Promise.all([
                        initPlatformInfo(),
                        app.sdk.initialize(),
                        initFeatBit(anonymousUser()),
                        initializeI18n()
                    ])];
            case 2:
                _a.sent();
                initRoute({ noTrack: !!page });
                if (page) {
                    setFirstScreenRoute(page);
                }
                return [4, switchFeatBitUser()];
            case 3:
                _a.sent();
                return [4, newHomeConfig({ needInitFeatBit: false, needInitI18n: false })];
            case 4:
                _a.sent();
                startFmpPrefetch();
                startMfeLoad();
                setStaffDefaultLanguage();
                setNetworkAdapter();
                initializeTitle();
                registerAPI();
                SW.start();
                page && api.go(page);
                trackFMP(page);
                return [3, 6];
            case 5:
                e_1 = _a.sent();
                console.error('init error', e_1);
                return [3, 6];
            case 6: return [2];
        }
    });
}); };
var initPromise = null;
export var appDataInitialize = function () { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                initPromise = init();
                return [4, initPromise];
            case 1:
                _a.sent();
                return [2];
        }
    });
}); };
export var bootstrap = function () { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!initPromise) return [3, 2];
                return [4, initPromise];
            case 1:
                _a.sent();
                initPromise = null;
                _a.label = 2;
            case 2:
                startup();
                return [2];
        }
    });
}); };
